module.exports = __webpack_public_path__ + "img/horizontal_1_1_9016.05037ee6.png";